module.exports = __webpack_public_path__ + "assets/img/warrior-name-61581a3a.png";